import { useRecoilValue } from "recoil";
import upperDataStore from "../stores/upperData";

export const useConfig = () => {
    const { config } = useRecoilValue(upperDataStore);
    return config;
};